import React from 'react';
import ioofLogo from '../../assets/ioof-logo.png'

const OurMission = () => {

    const h2Style = {
        color: "#012F47",
        fontWeight: "bold",
        fontSize: "28px"
    }

  return (
            <div className="flex flex-col justify-center items-center mt-4 px-4">
                <img width="17%" alt="international order of odd fellows logo with three chains. The first chain is white with the letter F inside, second is blue with the letter L inside and the last is red with the letter T inside the chain." src={ioofLogo}></img>
                <h2 className="mt-2" style={h2Style}>Our Mission</h2>
                <div className="w-52 h-[0.75px] bg-[#012F47] mx-auto mt-1 mb-4 rounded-full"></div>
                <p className="mb-4 text-md text-[#012F47] px-6 md:px-24">
                        As Odd Fellows, our mission is to serve those in need;
                    orphans, widows, and anyone seeking fellowship, comfort, or a helping hand. 
                </p>
                <p className="mb-4 text-md text-[#012F47] px-6 md:px-24">
                    Here at the Livermore Lodge #219, we are committed to building a stronger, 
                    more compassionate community, one act of service at a time.
                </p>
            </div>
  )
}

export default OurMission;